import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryClient } from '@/lib/queryClient';
import type { DeviceStatus } from '@/lib/types';
import { useWebSocket } from './useWebSocket';

// Polled status (5s) fused with WebSocket pushes for sub-second refresh on activity.
export function useDeviceStatus(clientId: string | undefined) {
  const enabled = !!clientId;

  const q = useQuery({
    queryKey: ['device-status', clientId],
    queryFn: () => api<DeviceStatus>(`/api/devices/${clientId}/status`),
    enabled,
    refetchInterval: 5_000,
  });

  useWebSocket((msg) => {
    if (!enabled) return;
    if (msg.type === 'device-status' && msg.clientId === clientId) {
      queryClient.setQueryData<DeviceStatus | undefined>(['device-status', clientId], (prev) => {
        // Merge — server's last_status payload comes back through GET; WS pushes the fresh data
        return { ...(prev ?? {} as DeviceStatus), ...msg.data, online: true };
      });
    } else if (msg.type === 'device-offline' && msg.clientId === clientId) {
      queryClient.setQueryData<DeviceStatus | undefined>(['device-status', clientId], (prev) => {
        if (!prev) return prev;
        return { ...prev, online: false };
      });
    }
  });

  return q;
}
